/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Error_TitleInputs */

const en_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fr_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur`)
};

const de_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const it_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore`)
};

const ru_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка`)
};

const es_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const zh_cn2_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const ja_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const hi_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलती`)
};

const pt_pt2_iframe_remote_error_title = /** @type {(inputs: Iframe_Remote_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Iframe_Remote_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_error_title = /** @type {((inputs?: Iframe_Remote_Error_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Error_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_error_title(inputs)
	if (locale === "de") return de_iframe_remote_error_title(inputs)
	if (locale === "it") return it_iframe_remote_error_title(inputs)
	if (locale === "ru") return ru_iframe_remote_error_title(inputs)
	if (locale === "es") return es_iframe_remote_error_title(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_error_title(inputs)
	if (locale === "ja") return ja_iframe_remote_error_title(inputs)
	if (locale === "hi") return hi_iframe_remote_error_title(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_error_title(inputs)
	return en_iframe_remote_error_title(inputs)
});